import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const LinkStyled = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
